











import Vue from 'vue';

export default Vue.extend({
  name: 'TheToolTip',
  data: () => ({
    show: false,
  }),
  props: {
    position: {
      default: 'left bottom',
      type: String,
    },
  },
});
